export default __webpack_public_path__ + "static/media/email-large.013d51fb.svg";